import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authReducer";
import homeReducer from "./reducers/homeReducer";
import moreReducer from "./reducers/moreReducer";
import orderReducer from "./reducers/orderReducer";
import getStartReducer from "./reducers/getStartReducer";
import lessonsReducer from "./reducers/lessonsReducer";
import weightReducer from "./reducers/weightReducer";
import knowledgebaseReducer from "./reducers/knowledgebaseReducer";
import embedReducer from "./reducers/embedReducer";

const store = configureStore({
  reducer: {
    authReducer,
    homeReducer,
    moreReducer,
    orderReducer,
    getStartReducer,
    lessonsReducer,
    weightReducer,
    knowledgebaseReducer,
    embedReducer,
    
  },
});

export default store;
